import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import Cookies from 'js-cookie';
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
	token:null,
	user:null
  },
  mutations: {
	changeToken(state,newValue){
		state.token = newValue
		Cookies.set('token', JSON.stringify(newValue));
	},
	changeUser(state,newValue){
		state.user = newValue
		Cookies.set('user', JSON.stringify(newValue));
	},
	
  },
});
const data = {}

const token = Cookies.get('token')
if (token) {
  data.token = JSON.parse(token)
}
const user = Cookies.get('user')
if (user) {
  data.user = JSON.parse(user)
}
store.replaceState(data);

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js